<template>

  <div id="error-page">
    <figure class="error-image">
      <img alt="404" class="image" src="@/assets/website/404.svg">
    </figure>

    <div class="m-page-container text-center">
      <h1 class="mb-2 text-3xl leading-tight">{{ $trans.t('errors._404.title') }}</h1>
      <p class="mb-6 leading-tight">{{ $trans.t('errors._404.description') }}</p>

      <m-button
        :appearance="$const.StyleAppearance.SECONDARY"
        :icon-before="{ name: 'home', solid: true, type: $const.IconTypes.FONT_AWESOME, }"
        :to="{ name: 'seoHome' }"
        class="mb-1.5"
      >
        {{ $trans.t('app.labels.backHome') }}
      </m-button>
      <a
        class="underline text-tiny"
        href="#"
        onClick="window.Intercom('show')"
      >
        {{ $trans.t('app.labels.contactCustomerSupport') }}
      </a>
      <br/>
    </div>
  </div>

</template>


<style lang="scss" scoped>

#error-page {
  @apply flex flex-col items-center justify-center bg-repeat bg-blue-25;
  background-image: url('@/assets/onboarding-bg.svg');
  min-height: calc(theme('height.screen') - theme('height.14'));
}

.m-page-container {
  @apply flex flex-col items-center;
}

.error-image {
  @apply h-64;

  .image {
    @apply h-full object-cover;
  }
}

</style>
